'use strict';

const { getDependencyClass } = require('../../lib/dependencies');
const performanceMeasure = require('../../lib/performanceMeasure.js');

let measure = performanceMeasure('webcomponents:knownUser');
const ANON_CLASS = 'is-anonymous';
const KNOWN_CLASS = 'is-known';

getDependencyClass('phoenix-page').then((pageClass) => {
    /**
     * phoenix-known-user is a wrapper for elements that should display conditionally
     * based on whether or not the viewer of the page is logged in to the Tempest site.
     * It looks for a user id in the RGIS cookie set by the membership login components,
     * and if the cookie exists, makes a request to Taiga to get profile and subscription
     * information for the user with that id. A global promise is used so that multiple
     * instances of phoenix-known-user can coexist on a page without making redundant
     * requests to Taiga.
     *
     * If the user is known (RGIS cookie exists and Taiga responds with data), a class
     * is applied to show all children of phoenix-known-user that have the KNOWN_CLASS,
     * and hide all children that have the ANON_CLASS. If no known user is found, the
     * reverse show/hide logic is applied.
     *
     * With a known user, the component also dispatches a custom event containing the
     * data from Taiga about the user profile. Other elements can listen for the event
     * and display the subscription or profile information accordingly.
     */
    class KnownUser extends pageClass.PhoenixElement {
        connectedCallback() {
            this.profileLoadedEvent = this.getAttr('profile-loaded-event');
            this.loginEvent = this.getAttr('login-event');
            this.logoutEvent = this.getAttr('logout-event');
            this.checkAndUpdateUser();

            if (this.loginEvent) {
                window.addEventListener(this.loginEvent, this.checkAndUpdateUser.bind(this));
            }

            if (this.logoutEvent) {
                window.addEventListener(this.logoutEvent, () => {
                    this.removeCookie('RGIS');
                    this.removeCookie('mct');
                    this.removeCookie('mut');
                    this.setAnonymous();
                    window.location.href = '/';
                });
            }
        }

        checkAndUpdateUser(evt) {
            this.getKnownUser().then((knownUser) => {
                if (knownUser) {
                    if (this.profileLoadedEvent) {
                        this.dispatchEvent(
                            new CustomEvent(this.profileLoadedEvent, {
                                bubbles: true,
                                detail: {
                                    knownUser,
                                },
                            })
                        );
                    }
                    this.setKnown();
                } else {
                    this.setAnonymous();
                }
            });
        }

        toggle(active, inactive) {
            [...this.getElementsByClassName(active)].forEach((el) => {
                el.classList.add('known-user-active-state');
            });
            [...this.getElementsByClassName(inactive)].forEach((el) => {
                el.classList.remove('known-user-active-state');
            });
        }

        setAnonymous() {
            this.toggle(ANON_CLASS, KNOWN_CLASS);
        }

        setKnown() {
            this.toggle(KNOWN_CLASS, ANON_CLASS);
        }
    }

    window.customElements.define('phoenix-known-user', KnownUser);
    measure.end();
});
